
const digest = '28ab3fcd13adc95c82b2d44122e44ae0106c55e7d7de7d03fa07c1870e032973';
const css = `._tableSizerContainer_17vti_1 {
  padding: 0 9px;
  box-sizing: border-box;
}

._tableSizer_17vti_1 {
  margin: 0 auto;
  border-collapse: collapse;
}

._cell_17vti_11 {
  width: 19px;
  height: 19px;
  border: 1px solid var(--theme-primary-border);
  padding: 0;
}

._selected_17vti_18 {
  background-color: var(--theme-menu-active-background);
  border: 1px solid var(--aha-blue-300);
}

._dimensions_17vti_23 {
  margin-top: 4px;
}
`;

(function() {
  if (!document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
    
export default {"tableSizerContainer":"_tableSizerContainer_17vti_1","tableSizer":"_tableSizer_17vti_1","cell":"_cell_17vti_11","selected":"_selected_17vti_18","dimensions":"_dimensions_17vti_23"};
export { css, digest };
  